import * as React from 'react';
import '../../css/auth.css';

class SilvermouseInfo extends React.Component {

    render() {
        return (
            <div className='pt-2 m-0 loginBoxLinks'>
                <h2 className='mt-2'>Silvermouse Info</h2>
                <p>You have been logged out, please login again</p>
                <br />
                <p>Return to the <a href='/' title='log out'>log in</a> page</p>
            </div>
        );
    }
}

export default SilvermouseInfo;


// WEBPACK FOOTER //
// ./src/components/Auth/SilvermouseInfo.js